"use client";

import * as React from "react";
import { Clock2Icon } from "lucide-react";
import { Card, CardContent, CardFooter } from "@/client/components/shad/card";
import { Field, FieldGroup, FieldLabel } from "@/client/components/shad/field";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/client/components/shad/input-group";
import { Calendar } from "@/client/components/shad/calendar";
import { Separator } from "@/client/components/shad/separator";
import { Button } from "@/client/components/shad/button";
import { IconCloudDown } from "@tabler/icons-react";

export function PdarCalander() {
  const [date, setDate] = React.useState<Date | undefined>(
    new Date(new Date().getFullYear(), new Date().getMonth(), 12),
  );

  return (
    <div className="grid gap-6 -ml-1">
      <Calendar mode="single" selected={date} onSelect={setDate} />
      <Separator />
      <FieldGroup className="pl-4 pr-3">
        <Field>
          <FieldLabel htmlFor="time-from">Start Time</FieldLabel>
          <InputGroup>
            <InputGroupInput
              id="time-from"
              type="time"
              step="1"
              defaultValue="10:30:00"
              className="appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
            />
            <InputGroupAddon>
              <Clock2Icon className="text-muted-foreground" />
            </InputGroupAddon>
          </InputGroup>
        </Field>
        <Field>
          <FieldLabel htmlFor="time-to">End Time</FieldLabel>
          <InputGroup>
            <InputGroupInput
              id="time-to"
              type="time"
              step="1"
              defaultValue="12:30:00"
              className="appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
            />
            <InputGroupAddon>
              <Clock2Icon className="text-muted-foreground" />
            </InputGroupAddon>
          </InputGroup>
        </Field>
      </FieldGroup>
      <Separator />
      <div className="px-3 flex flex-col gap-3  rounded-md">
        <div className="grow font-mono">{date?.toDateString()}</div>
        <Button variant="secondary" size="sm">
          <IconCloudDown className="-ml-3" />
          Fetch logs
        </Button>
      </div>
    </div>
  );
}
